import Feature from 'Services/Feature';

const isMarginEnabled = () => {
    return Feature.isEnabled('email-engine') && Feature.isEnabled('add-margin-paragraphs-richtext');
};

const addBrToEmptyPragraphs = (html) => {
    return html.replace(/<p[^>]*><\/p>/g, '<p><br class="ProseMirror-trailingBreak"></p>');
};
const editorClass = () => {
    return isMarginEnabled() ? 'has-margins' : '';
};

const replaceTagsWithSpan = (content, tags) => {
    if (!tags || !tags.length) {
        return content;
    }
    for (const tag of tags) {
        const regex = new RegExp(tag.key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
        content = content.replace(
            regex,
            `<span class="custom-tags-and-fields custom-tags-and-fields__default typographies-paragraph-small-bold" tag="${tag.key}">${tag.name}</span>`,
        );
    }
    return content;
};

const replaceSpansWithTags = (content, tags) => {
    if (!tags || !tags.length || !content) {
        return content;
    }

    const regex =
        /<span (?=[^>]*tag="([^"]+)")(?=[^>]*class="[^"]*custom-tags-and-fields[^"]*")[^>]*>[^<]+<\/span>/g;
    return content.replace(regex, (match, tag) => {
        const tagObj = tags.find((t) => t.key === tag);
        return tagObj ? tagObj.key : match;
    });
};

export {
    addBrToEmptyPragraphs,
    editorClass,
    isMarginEnabled,
    replaceTagsWithSpan,
    replaceSpansWithTags,
};
